<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Nombre -->
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.form.name.label')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="itemData.name"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Nombre -->
            <validation-provider
              #default="validationContext"
              name="provider"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.form.provider.label')"
                label-for="provider"
              >
                <b-form-input
                  id="provider"
                  v-model="itemData.provider"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Record Type -->
            <validation-provider
              #default="validationContext"
              name="type"
              rules="required"
            >
              <b-form-group
                :label="$t('generic_devices.form.type.placeholder')"
                label-for="type"
                class="text-capitalize"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.type"
                  :options="recordTypeOptions"
                  :reduce="(val) => val.value"
                  input-id="type"
                  :clearable="false"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">{{
                  validationContext.errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- protocol -->
            <validation-provider
              #default="validationContext"
              name="protocol"
              rules="required"
            >
              <b-form-group
                :label="$t('generic_devices.form.custom_fields.protocol.label')"
                label-for="protocol"
                class="text-capitalize"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.protocol"
                  :options="[
                    { value: 'rtsp', label: 'RTSP' },
                    { value: 'rtmp', label: 'RTMP' },
                  ]"
                  :reduce="(val) => val.value"
                  input-id="protocol"
                  :clearable="false"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">{{
                  validationContext.errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <!-- Type -->
            <validation-provider
              #default="validationContext"
              name="Type"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.camera_type')"
                label-for="id_type"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="typeOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_type"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Tags -->
            <validation-provider #default="validationContext" name="Tag">
              <b-form-group
                class="text-capitalize"
                label="Tag"
                label-for="id_device_tag"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_device_tag"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="deviceTagsOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_device_tag"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="4">
            <!-- Enable RSTP -->
            <validation-provider name="alarm" rules="required" vid="rtsp_available">
              <b-form-checkbox
                id="rtsp_available"
                v-model="itemData.rtsp_available"
                name="rtsp_available"
                :value="1"
                class="my-1 text-capitalize"
                unchecked-value="0"
                switch
              >
                {{ $t("camera_proxy.rtsp_available") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <b-form-checkbox
              id="on_demand"
              v-model="itemData.on_demand"
              name="on_demand"
              :value="1"
              class="my-1 text-capitalize"
              unchecked-value="0"
              switch
            >
              {{ $t("camera_proxy.on_demand") }}
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-form-checkbox
              id="enabled_onvif_events"
              v-model="itemData.enabled_onvif_events"
              name="enabled_onvif_events"
              :value="1"
              class="my-1 text-capitalize"
              unchecked-value="0"
              switch
            >
              {{ $t("generic_devices.form.custom_fields.enabled_onvif_events.label") }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <!-- proxy rtsp server -->
            <validation-provider
              v-show="itemData.rtsp_available == 1"
              #default="validationContext"
              :name="$tc('proxy_rtsp_server.title', 1)"
              rules="required_if:rtsp_available,1"
            >
              <b-form-group
                class="text-capitalize"
                :label="$tc('proxy_rtsp_server.title', 1)"
                label-for="id_proxy_rtsp_server"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_proxy_rtsp_server"
                  :options="proxyRtspServersOptions"
                  :reduce="(val) => val.value"
                  input-id="id_proxy_rtsp_server"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- path -->
            <validation-provider
              v-show="itemData.rtsp_available == 1"
              #default="validationContext"
              :name="$t('generic_devices.path')"
              rules="required_if:rtsp_available,1"
            >
              <b-form-group :label="$t('generic_devices.path')" label-for="path">
                <b-form-input
                  id="path"
                  v-model="itemData.path"
                  :placeholder="$t('generic_devices.path')"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <p class="ml-2 mb-1">
          {{ $t("generic_devices.onvif") }}
        </p>

        <b-row class="mx-0">
          <b-col cols="6">
            <validation-provider #default="validationContext" name="onvif_host">
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.form.custom_fields.onvif_host.label')"
                label-for="onvif_host"
              >
                <b-form-input
                  id="onvif_host"
                  v-model="itemData.onvif_host"
                  :state="getValidationState(validationContext)"
                  trim
                  autocomplete="off"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- onvif_port -->
            <validation-provider
              #default="validationContext"
              name="onvif_port"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.form.custom_fields.onvif_port.label')"
                label-for="onvif_port"
              >
                <b-form-input
                  id="onvif_port"
                  v-model="itemData.onvif_port"
                  :state="getValidationState(validationContext)"
                  name="onvif_port"
                  type="number"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mx-0">
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              :name="$t('generic_devices.form.custom_fields.user.label')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.form.custom_fields.user.label')"
                label-for="user"
              >
                <b-form-input
                  id="user"
                  v-model="itemData.user"
                  :state="getValidationState(validationContext)"
                  trim
                  autocomplete="off"
                  :disabled="!isAdd"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- password -->
            <validation-provider
              #default="validationContext"
              name="password"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('generic_devices.form.custom_fields.password.label')"
                label-for="password"
              >
                <b-form-input
                  id="password"
                  v-model="itemData.password"
                  :state="getValidationState(validationContext)"
                  name="password"
                  type="password"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <!-- Get From Onvif -->
            <validation-provider
              name="alarm"
              vid="get_from_onvif">
              <b-form-checkbox
                id="get_from_onvif"
                name="get_from_onvif"
                v-model="itemData.get_from_onvif"
                :value="1"
                class="my-1 text-capitalize"
                unchecked-value="0"
                switch
              >
                {{ $t("generic_devices.get_from_onvif") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <!-- url -->
            <validation-provider
              v-if="itemData.get_from_onvif == 1"
              #default="validationContext"
              name="url"
              rules="required">
              <b-form-group class="text-capitalize" label="url" label-for="url">
                <v-select
                  v-model="itemData.url"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="streamOptions"
                  :clearable="false"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <!-- url -->
            <validation-provider
              v-if="itemData.get_from_onvif != 1"
              #default="validationContext"
              name="url"
              rules="required">
              <b-form-group class="text-capitalize" label="url*" label-for="url">
                <b-form-input
                  id="url"
                  v-model="itemData.url"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <!-- url -->
            <b-form-group class="text-capitalize" label="sub url" label-for="subUrl">
              <b-form-input
                id="subUrl"
                v-model="itemData.subUrl"
                trim
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { ref, computed, onMounted, watch } from "@vue/composition-api";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from "axios";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
  },
  props: {
    typeOptions: {
      type: Array,
      required: true,
    },
    proxyRtspServersOptions: {
      type: Array,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
    propItemData: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    onMounted(() => store.dispatch('tenant/getDeviceTags'));

    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    const recordTypeOptions = [
      {
        label: t("generic_devices.types.camera"),
        value: "camera",
      },
      {
        label: t("generic_devices.types.generic_device"),
        value: "generic_device",
      },
    ];

    const streamOptions = ref([]);

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:itemData", { [key]: newValue });
            if (key == "get_from_onvif" && newValue == 1) {
              getStreams()
            }
          }
        }
      );
    };

    watch(
      () => props.propItemData,
      (newValue) => {
        itemData.value = { ...newValue };
      },
      { deep: true }
    );

    setupWatcher(itemData, "name");
    setupWatcher(itemData, "provider");
    setupWatcher(itemData, "type");
    setupWatcher(itemData, "url");
    setupWatcher(itemData, "id_type");
    setupWatcher(itemData, "id_device_tag");
    setupWatcher(itemData, "rtsp_available");
    setupWatcher(itemData, "on_demand");
    setupWatcher(itemData, "enabled_onvif_events");
    setupWatcher(itemData, "id_proxy_rtsp_server");
    setupWatcher(itemData, "path");
    setupWatcher(itemData, "onvif_host");
    setupWatcher(itemData, "onvif_port");
    setupWatcher(itemData, "user");
    setupWatcher(itemData, "password");
    setupWatcher(itemData, "protocol");
    setupWatcher(itemData, "get_from_onvif");
    setupWatcher(itemData, "subUrl");

    const deviceTagsOptions = computed(() => {
      return store.getters["tenant/getDeviceTags"].map((item) => ({
        label: item.name,
        value: item.id,
      }));
    });

    const getStreams = ()  => {
      let cameraData = {
        camera_ip: itemData.value.onvif_host,
        camera_port: itemData.value.onvif_port,
        camera_user: itemData.value.user,
        camera_pass: itemData.value.password,
      };
      try {
        axios
          .post(`${window.__env.VUE_APP_ONVIF_URL}/streams`, {
            ...cameraData,
          })
          .then(({ data }) => {
            streamOptions.value = data;
          });
      } catch (error) {}
    }

    return {
      refFormObserver,
      getValidationState,
      validateStep,
      deviceTagsOptions,
      itemData,
      recordTypeOptions,
      streamOptions
    };
  },
};
</script>
